import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, Input, Menu, Modal, Table, message } from 'antd';
import { Api } from '../../lib/api';
import './styles.scss';

export default class Labels extends Component {
    state = {
        id: null,
        reportBro: false,
        name: null,
        modalVisible: false,
        closeAfterSave: false
    };

    render() {
        if (this.state.reportBro) {
            return (
                <div id="labels-page" style={{ position: 'relative' }}>
                    <Modal
                        open={this.state.modalVisible}
                        title="Unsaved Changes"
                        onCancel={() => this.setState({ modalVisible: false })}
                        closable={false}
                        destroyOnClose={true}
                        footer={[
                            <Button
                                key="discard"
                                type="danger"
                                onClick={() => this.setState({ modalVisible: false, reportBro: false })}
                            >
                                Discard
                            </Button>,
                            <Button
                                key="save"
                                type="primary"
                                onClick={() => {
                                    let iframeWindow = document.getElementById('reportbro-frame').contentWindow;
                                    let reportBro = iframeWindow.$('#reportbro');
                                    this.setState({ closeAfterSave: true });
                                    reportBro.reportBro('save');
                                }}
                            >
                                Save
                            </Button>
                        ]}
                    >
                        Some changes have not been saved.
                    </Modal>
                    <iframe
                        id="reportbro-frame"
                        title="Create Label"
                        onLoad={() => {
                            // Tie a function to the iframe window. The iframe will call it on every save attempt.
                            document.getElementById('reportbro-frame').contentWindow.labelSaved = (success) => {
                                if (success) {
                                    // Successfully saved
                                    message.success('Label saved', 3);

                                    // If this was done from the Save/Discard modal, close the modal and close ReportBro
                                    if (this.state.closeAfterSave) {
                                        this.setState({
                                            modalVisible: false,
                                            reportBro: false
                                        });
                                    }
                                } else {
                                    message.error('Failed to save label');
                                }

                                // Reset 'closeAfterSave' regardless of the save outcome
                                this.setState({
                                    closeAfterSave: false
                                });
                            };
                        }}
                        src={
                            'reportbro/reportbro.html?type=label' +
                            (this.state.id === null ? '' : '&id=' + this.state.id) +
                            (this.state.id === null && this.state.name !== null ? '&name=' + this.state.name : '')
                        }
                    ></iframe>
                    <Button
                        id="reportbro-close"
                        onClick={() => {
                            let reportBro = document.getElementById('reportbro-frame').contentWindow.window.reportBroInstance;

                            // Get the modified status of the ReportBro document
                            if (!reportBro.modified) {
                                // No changes to document.
                                // Leave Report Bro.
                                this.setState({ reportBro: false });
                                return;
                            }

                            // Unsaved changes. Show the Save/Discard modal
                            this.setState({ modalVisible: true });
                        }}
                    >
                        Close
                    </Button>
                </div>
            );
        }

        return (
            <div id="labels-page">
                <LabelList updateReportBro={(id, name, show) => this.setState({ id: id, name: name, reportBro: show })} />
            </div>
        );
    }
}

class LabelList extends Component {
    static propTypes = {
        updateReportBro: PropTypes.func
    };

    state = {
        labels: [],
        rename: {},
        newName: {},
        focusedInput: null,
        modalVisible: false,
        createLabelName: null
    };

    componentDidMount() {
        this.getLabels();
    }

    getLabels() {
        Api.getLabels().then((labels) => {
            this.setState({ labels });
        });
    }

    import() {
        let input = document.createElement('input');
        input.type = 'file';
        input.setAttribute('multiple', '');

        input.addEventListener('change', () => {
            for (let i = 0; i < input.files.length; i++) {
                this.importFile(input.files[i]);
            }
        });

        input.click();
    }

    importFile(file) {
        let reader = new FileReader();
        reader.onload = (text) => {
            try {
                let label = JSON.parse(text.target.result);

                Api.createLabel({
                    name: label.name,
                    reportSpec: label.reportSpec
                }).then(() => this.getLabels());
            } catch (e) {
                console.error(e);
                // Skip
            }
        };

        reader.readAsText(file);
    }

    export(id) {
        Api.getLabel(id).then((label) => {
            let link = document.createElement('a');
            let name = label.name.replace(/[^\w -]/g, ' ').trim();
            link.download = name.length > 0 ? name + '.txt' : 'label.txt';
            let json = JSON.stringify(label);
            link.href = 'data:,' + encodeURIComponent(json);
            link.click();
        });
    }

    async duplicate(id) {
        let label = await Api.getLabel(id);
        await Api.createLabel({
            name: label.name,
            reportSpec: label.reportSpec
        });
        this.getLabels();
    }

    async deleteLabel(id) {
        await Api.deleteLabel(id);
        this.getLabels();
    }

    async rename(id) {
        try {
            await Api.updateLabel(id, { name: this.state.newName[id] });
            this.setState((state) => ({ rename: { ...state.rename, [id]: false } }));
        } catch (e) {}
        this.getLabels();
    }

    createLabel() {
        this.props.updateReportBro(null, this.state.createLabelName, true);
    }

    render() {
        return (
            <React.Fragment>
                <Modal
                    open={this.state.modalVisible}
                    title="Label Name"
                    onCancel={() => this.setState({ modalVisible: false })}
                    closable={false}
                    destroyOnClose={true}
                    footer={[
                        <Button key="submit" type="primary" onClick={() => this.createLabel()}>
                            Create
                        </Button>,
                        <Button key="back" onClick={() => this.setState({ modalVisible: false })}>
                            Cancel
                        </Button>
                    ]}
                >
                    <Input
                        ref={(element) => element && element.focus()}
                        onChange={(e) => this.setState({ createLabelName: e.target.value })}
                        onKeyUp={(e) => {
                            if (e.keyCode === 13) {
                                this.createLabel();
                            } else if (e.keyCode === 27) {
                                this.setState({ modalVisible: false });
                            }
                        }}
                    />
                </Modal>
                <Table
                    className="label-list"
                    columns={[
                        {
                            title: 'Label',
                            dataIndex: 'name',
                            defaultSortOrder: 'ascend',
                            sortDirections: ['ascend', 'descend'],
                            sorter: (a, b) => a.name.localeCompare(b.name),
                            render: (text, record) => (
                                <React.Fragment>
                                    {record.id in this.state.rename && this.state.rename[record.id] ? (
                                        <React.Fragment>
                                            <Input
                                                ref={(element) =>
                                                    this.state.focusedInput === record.id && element && element.focus()
                                                }
                                                defaultValue={text}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 13) {
                                                        this.rename(record.id);
                                                    } else if (e.keyCode === 27) {
                                                        this.setState((state) => ({
                                                            rename: { ...state.rename, [record.id]: false }
                                                        }));
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    let v = e.target.value;
                                                    this.setState((state) => ({
                                                        newName: { ...state.newName, [record.id]: v }
                                                    }));
                                                }}
                                            />
                                            <Button type="primary" onClick={() => this.rename(record.id)}>
                                                Save
                                            </Button>
                                            <Button
                                                type="danger"
                                                onClick={() =>
                                                    this.setState((state) => ({
                                                        rename: { ...state.rename, [record.id]: false }
                                                    }))
                                                }
                                            >
                                                Cancel
                                            </Button>
                                        </React.Fragment>
                                    ) : (
                                        text
                                    )}
                                </React.Fragment>
                            )
                        },
                        {
                            title: 'Created',
                            dataIndex: 'createdAt',
                            align: 'center',
                            sortDirections: ['ascend', 'descend'],
                            sorter: (a, b) => a.createdAt.localeCompare(b.createdAt)
                        },
                        {
                            title: 'Last Modified',
                            dataIndex: 'updatedAt',
                            align: 'center',
                            sortDirections: ['ascend', 'descend'],
                            sorter: (a, b) => a.updatedAt.localeCompare(b.updatedAt)
                        },
                        {
                            title: (
                                <div>
                                    <Button
                                        style={{ marginBottom: '3px' }}
                                        onClick={() => this.setState({ modalVisible: true })}
                                    >
                                        Create
                                    </Button>
                                    <Button onClick={() => this.import()}>Import</Button>
                                </div>
                            ),
                            align: 'center',
                            width: '50px',
                            render: (text, record) => (
                                <Dropdown
                                    overlay={
                                        <Menu>
                                            <Menu.Item onClick={() => this.props.updateReportBro(record.id, null, true)}>
                                                Edit
                                            </Menu.Item>
                                            <Menu.Item
                                                onClick={() =>
                                                    this.setState((state) => ({
                                                        rename: { ...state.rename, [record.id]: true },
                                                        focusedInput: record.id
                                                    }))
                                                }
                                            >
                                                Rename
                                            </Menu.Item>
                                            <Menu.Item onClick={() => this.duplicate(record.id)}>Duplicate</Menu.Item>
                                            <Menu.Item onClick={() => this.export(record.id)}>Export</Menu.Item>
                                            <Menu.Divider />
                                            <Menu.Item onClick={() => this.deleteLabel(record.id)}>Delete</Menu.Item>
                                        </Menu>
                                    }
                                    trigger={['click']}
                                >
                                    <div className="menu-label">
                                        <MoreOutlined />
                                    </div>
                                </Dropdown>
                            )
                        }
                    ]}
                    dataSource={this.state.labels}
                    rowKey="id"
                    pagination={false}
                />
            </React.Fragment>
        );
    }
}
